import pick from 'lodash/pick';
import moment from 'moment';
import isEqual from 'lodash/isEqual';
import { WeekDays } from 'dash-common';

type TWorkingHours = Record<
  string,
  { from: string; to: string; __typename: string }
>;

const formatValues = (obj: any) =>
  Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, value || null])
  );

const getExistedWorkingHours = (workingHours: TWorkingHours) => {
  const existedWorkingHours = Object.entries(workingHours || {}).reduce(
    (memo, [key, value]) => {
      if (value) {
        const { __typename, ...rest } = value;

        return {
          ...memo,
          [key]: rest,
        };
      }
      return memo;
    },
    {}
  );

  return existedWorkingHours;
};

const compareWorkingHours = (
  currentWorkingHours: TWorkingHours,
  savedWorkingHours: TWorkingHours
) => {
  const fieldsToPick = Object.values(WeekDays);

  const existedCurrentWorkingHours =
    getExistedWorkingHours(currentWorkingHours);
  const existedSavedWorkingHours = getExistedWorkingHours(savedWorkingHours);

  const currentWorkingHoursToCompare = pick(
    existedCurrentWorkingHours,
    fieldsToPick
  );
  const savedWorkingHoursToCompare = pick(
    existedSavedWorkingHours,
    fieldsToPick
  );

  return isEqual(currentWorkingHoursToCompare, savedWorkingHoursToCompare);
};

const compareDates = (formStateDate: string, propertyDate: string) => {
  const formStateDateMoment = moment(formStateDate);
  const propertyDateMoment = moment(propertyDate);

  if (!formStateDate || !propertyDate) {
    return formStateDate === propertyDate;
  }

  return formStateDateMoment.isSame(propertyDateMoment, 'day');
};

export const compareAdvancedPropertyData = (
  property: any,
  formStateData: any
) => {
  const {
    errorSlug,
    isLoading,
    workingHours,
    completionDate,
    constructionStartDate,
    ...rest
  } = formStateData;
  const fields = Object.keys(rest);
  const propertiesToPick = fields.reduce(
    (memo: any, key: any) => ({
      ...memo,
      [key]: property[key],
    }),
    {}
  );

  const propertyData = formatValues(pick(propertiesToPick, fields));
  const formState = formatValues(pick(rest, fields));

  return (
    isEqual(propertyData, formState) &&
    compareDates(completionDate, property.completionDate) &&
    compareDates(constructionStartDate, property.constructionStartDate) &&
    compareWorkingHours(workingHours, property?.workingHours)
  );
};
